import React from 'react';
import './ServiceSingle.css';

import { Lightbox, PageTitle, SidebarHeading, Faqs } from '../../../components';
import { services } from '../../../constants';
import { renderIcon } from '../../../utils';

import { FaCheck } from 'react-icons/fa';
import { FaShirt } from 'react-icons/fa6';

import { Link, useLocation } from 'react-router-dom';



const ServiceSingle = () => {

  const location = useLocation();
  const serviceSingle = location.state;

  const features = serviceSingle.features;
  const procedure = serviceSingle.procedure;

  return (
    <>
      {/* Page Title */}
      <PageTitle title={serviceSingle.title} page={"Service Single"} />

      <section className='service-single page-single'>

        <div className='sidebar service-sidebar'>

          <div className='category sidebar-item'>

            <SidebarHeading title={'all services'} />

            <div className='box-container'>
              {services.map(service => {
                return  (
                /* Link to the individual service page */
                <Link
                  to={{
                    pathname: '/Services/' + service.title,
                  }}
                  location = {{service}}
                  state= {service}
                  key={service.id}
                  className='item'><span><div className='icon'>{renderIcon(service.title)}</div>{service.title}</span> {/* Service Title */}
                </Link> )
              })}
            </div>

          </div>

        </div>

        <div className='service-info page-info'>

          {/* Service Image */}
          <div className='image'>
            <img src={serviceSingle.image} alt={serviceSingle.title} />
          </div>

          <div className='content'>

            {/* Service heading */}
            <h3 className='main-heading'>{serviceSingle.title}</h3>

            {/* Service Content */}
            {serviceSingle.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

            {/* Service Image gallery */}
            <Lightbox images={serviceSingle.gallery} />

            {/* Section for Service Features */}
            <div className='service-benefits sub-section'>

              <h3 className='sub-heading'>Service Features</h3>
              <p>Key highlights of our {serviceSingle.title} service that reflect premium garment care, efficiency, and customer convenience:</p>

              {/* List of service benefits */}
              <ul>
                {features.map((feature, index) => {
                  return <li key={index}>
                    <div className='icon'><FaCheck /></div>
                    {feature}
                  </li>
                })}
              </ul>

            </div>

            {/* Service Process */}
            <div className='service-process sub-section'>

              <h3 className='sub-heading'>Service Process</h3>
              <p>We follow a reliable, step-by-step process to ensure your garments are cleaned, cared for, and returned fresh and spotless.</p>

              {/* List of Steps */}
              <ul>
                {procedure.map((step, index) => {
                  return <li key={index}>
                    <div className='icon'><FaShirt /></div>
                    {step}
                  </li>
                })}
              </ul>

            </div>

            {/* Section for frequently asked questions */}
            <div className='service-faqs sub-section'>

              <h3 className='sub-heading'>frequently asked questions</h3>

              {/* Faq Accordion container */}
              <Faqs faqs={serviceSingle.faqs} />

            </div>

          </div>
        
        </div> 

      </section> 
    </> 
  );
}

export default ServiceSingle;